import "./index.css";
import eventBus from "Bus";
import Lenders from "Management/Lenders";
import { useSelector } from "react-redux";
import { Modal, Spin, Tabs, Button } from "antd";
import React, { useCallback, useEffect, useRef, useState } from "react";
import ClosingCost from "Management/estimatedclosingfee/components/ClosingCost";
import LodestarTipsCard from "Management/estimatedclosingfee/components/LodestarTipsCard";

/**
 * @name EditMortgageRateCalculator 利率编辑器
 * @description 迁移目录 “InitialSetup / NewPreviewLandingPageSetup”
 */
const EditMortgageRateCalculator = ({ showEditBtn }) => {
  // const calculatorsRef = useRef(null);
  const closingCostRef = useRef(null);

  const [activeTabKey, setActiveTabKey] = useState("1");
  // const [hasLenders, setHasLenders] = useState(false);
  const [openEditModule, setOpenEditModule] = useState(false);

  const [closingFeeConfig, setClosingFeeConfig] = useState({
    originationCharges: null,
    canNotShopServices: null,
    canShopServices: null,
    taxesAndOtherGovernmentFees: null,
    prepaids: null,
    initialEscrowPaymentsAtClosing: null,
    other: null,
  });

  const [lodeStarConfig, setLodeStarConfig] = useState({
    suggestEnableCount: 1,
    isModified: false,
    enableOriginationCharges: false,
    enableCanNotShopServices: false,
    enableCanShopServices: false,
    enableTaxesAndOtherGovernmentFees: false,
    enablePrepaids: false,
    enableInitialEscrowPaymentsAtClosing: false,
    enableOther: false,
  });

  const subscription = useSelector((state) => {
    return state.subscriptionReducer.currentInfo;
  });

  // const getCustomerLenders = useCallback(async () => {
  //   try {
  //     const token = sessionStorage.getItem("ZeitroA");
  //     const response = await fetch("/data/getcustomerlenders", {
  //       method: "GET",
  //       headers: {
  //         Authorization: "Bearer " + token,
  //         Cache: "no-cache",
  //       },
  //     });

  //     if (!response.ok) {
  //       throw new Error(`HTTP error! status: ${response.status}`);
  //     }

  //     const data = await response.json();

  //     if (data.Status !== "OK") {
  //       throw new Error(`API error: ${JSON.stringify(data)}`);
  //     }

  //     const hasLenders = data.Lenders
  //       ? data.Lenders.some((item) => item.Active)
  //       : false;
  //     setHasLenders(hasLenders);
  //   } catch (error) {
  //     console.error("Error fetching customer lenders:", error);
  //   }
  // }, []);

  function getloanestimatedclosingfee() {
    let token = sessionStorage.getItem("ZeitroA");
    fetch("/los/getloanestimatedclosingfee", {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        Cache: "no-cache",
      },
    })
      .then((response) => {
        if (response.status !== 200) {
          alert(
            "Looks like there was a problem. Status Code: " + response.status,
          );
          return;
        }
        response.json().then((js) => {
          if (js.status !== "OK") {
            console.log("Error: " + js.Error);
          } else {
            let data = js.configurations;
            if (data.estimatedClosingCostsDetail) {
              setClosingFeeConfig(data.estimatedClosingCostsDetail);
            }
            if (data.lodeStarConfig) {
              setLodeStarConfig(data.lodeStarConfig);
            }
          }
        });
      })
      .catch(function (err) {
        console.log("Fetch Error :-S", err);
      });
  }

  function handleLodestarChange(checked) {
    let newLodeStarConfig = {
      ...lodeStarConfig,
      enableCanNotShopServices: checked,
      enableCanShopServices: checked,
      enableTaxesAndOtherGovernmentFees: checked,
      enablePrepaids: checked,
      enableInitialEscrowPaymentsAtClosing: checked,
      enableOther: checked,
    };
    const closingFee = closingCostRef.current.getClosingFee();
    setEstClosingfee(newLodeStarConfig, closingFee);
  }

  function handleConfigChange(newConfig) {
    const closingFee = closingCostRef.current.getClosingFee();
    setEstClosingfee(newConfig, closingFee);
  }

  function setEstClosingfee(lodeStarConfig, closingFeeConfig) {
    let data = {
      lodeStarConfig: {
        ...lodeStarConfig,
        isModified: true,
        enableCanNotShopServices: false,
        enablePrepaids: false,
        enableInitialEscrowPaymentsAtClosing: false,
      },
      closingCostsDetail: closingFeeConfig,
    };
    let token = sessionStorage.getItem("ZeitroA");
    fetch("/los/setloanestimatedclosingfee", {
      cache: "no-cache",
      method: "POST",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Cache: "no-cache",
      },
      body: JSON.stringify(data),
    })
      .then((response) => {
        if (!response.ok) {
        } else {
          eventBus.emit("closingFeeUpdated");
          getloanestimatedclosingfee();
        }
      })
      .catch((error) => {});
  }

  function handleTabChange(key) {
    setActiveTabKey(key);
  }

  function handleCancel() {
    // getCustomerLenders();
    setOpenEditModule(false);
  }

  function handleSaveClosingFee() {
    const closingFee = closingCostRef.current.getClosingFee();
    setEstClosingfee(lodeStarConfig, closingFee);
    handleCancel();
  }

  useEffect(() => {
    // getCustomerLenders();
    getloanestimatedclosingfee();
  }, []);

  return (
    <>
      {showEditBtn ? (
        <img
          src="/images/document-edit.svg"
          onClick={() => setOpenEditModule(true)}
        />
      ) : null}
      <Modal
        className={`EditModuleModal add-lenders-modal`}
        centered
        destroyOnClose={true}
        open={openEditModule}
        title=""
        footer={null}
        onCancel={handleCancel}
        width={1000}
      >
        <div className="moduleTitle">Edit mortgage rate calculator</div>
        <div className="edit-mortgage-rate-modal-content">
          <Spin spinning={false}>
            <Tabs
              className="edit-mortgage-rate-modal-tabs"
              activeKey={activeTabKey}
              onChange={handleTabChange}
            >
              <Tabs.TabPane tab="Add Lenders" key="1">
                <div className="add-lenders-content">
                  <div className="moduleDescribe">
                    In this step, you need to add at least one lender to
                    activate the calculator feature, allowing your potential
                    customers to access real-time rates based on demand.
                  </div>
                  <div
                    className="lenders-container"
                    style={{ margin: "0 -40px" }}
                  >
                    <Lenders
                      // ref={calculatorsRef}
                      // finish={calculatorsFinish}
                      cancel={handleCancel}
                      subscriptionReducer={subscription}
                      setUpgradeModalOpen={() => {
                        setOpenEditModule(false);
                      }}
                    />
                  </div>
                </div>
              </Tabs.TabPane>
              <Tabs.TabPane tab="Closing cost details" key="2" forceRender>
                <div className="closing-fees-content">
                  <div style={{ marginBottom: 12 }}>
                    <LodestarTipsCard
                      initialConfig={lodeStarConfig}
                      onLodestarChange={handleLodestarChange}
                    />
                  </div>
                  <div className="estimatedclosingfee-container">
                    <ClosingCost
                      ref={closingCostRef}
                      initialConfig={lodeStarConfig}
                      initialClosingFee={closingFeeConfig}
                      onConfigChange={handleConfigChange}
                      onAddLenderClick={() => setActiveTabKey("1")}
                    />
                  </div>
                </div>
              </Tabs.TabPane>
            </Tabs>
          </Spin>
        </div>
        <div className="edit-mortgage-rate-modal-footer">
          <Button
            className="edit-mortgage-rate-modal-close-btn"
            type="link"
            variant="customize"
            onClick={handleCancel}
          >
            Cancel
          </Button>
          <Button
            className="edit-mortgage-rate-modal-save-btn"
            variant="primary"
            onClick={handleSaveClosingFee}
          >
            Save
          </Button>
        </div>
      </Modal>
    </>
  );
};

export default EditMortgageRateCalculator;
